"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface AnimatedArrowsProps {
  className?: string;
}

export default function AnimatedArrows({ className }: AnimatedArrowsProps) {
  // Animation variants for each row group (top to bottom)
  const arrowVariants = {
    hidden: { opacity: 0.1 },
    visible: (custom: number) => ({
      opacity: [0.1, 1, 0.1],
      transition: {
        duration: 2,
        repeat: Infinity,
        delay: custom * 0.5,
        ease: "easeInOut",
      },
    }),
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="297"
      height="170"
      viewBox="0 0 297 170"
      fill="none"
      className={cn("w-full h-auto", className)}
    >
      {/* Row 1 - Top row (all 5 arrow columns, first section) */}
      <motion.g
        variants={arrowVariants}
        initial="hidden"
        animate="visible"
        custom={0}
      >
        <g opacity="0.1">
          <g opacity="0.87">
            <rect
              x="30.4614"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="8.30811"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="24.9229"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="13.8462"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="30.4614"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="8.30811"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="24.9229"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="13.8462"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="19.3843"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3843 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="30.4614"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="8.30811"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="24.9229"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="13.8462"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="19.3843"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3843 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="19.3843"
              y="27.6917"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3843 27.6917)"
              fill="#103037"
              fillOpacity="0.5"
            />
          </g>
        </g>

        <g opacity="0.14">
          <g opacity="0.87">
            <rect
              x="95.7114"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="73.5576"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5576 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="90.1729"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="79.0962"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="95.7114"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="73.5576"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5576 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="90.1729"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="79.0962"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="84.6343"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6343 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="95.7114"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="73.5576"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5576 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="90.1729"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="79.0962"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="84.6343"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6343 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="84.6343"
              y="27.6917"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6343 27.6917)"
              fill="#103037"
              fillOpacity="0.5"
            />
          </g>
        </g>

        <g filter="url(#filter0_d_4292_2547)">
          <g opacity="0.5">
            <rect
              x="160.961"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="138.808"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="155.423"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="144.346"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="160.961"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="138.808"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="155.423"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="144.346"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="149.884"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="160.961"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="138.808"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="155.423"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="144.346"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="149.884"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="149.884"
              y="27.6917"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 27.6917)"
              fill="#103037"
              fillOpacity="0.5"
            />
          </g>
        </g>

        <g opacity="0.14">
          <g opacity="0.87">
            <rect
              x="226.211"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="204.058"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="220.673"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="209.596"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="226.211"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="204.058"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="220.673"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="209.596"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="215.134"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.134 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="226.211"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="204.058"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="220.673"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="209.596"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="215.134"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.134 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="215.134"
              y="27.6917"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.134 27.6917)"
              fill="#103037"
              fillOpacity="0.5"
            />
          </g>
        </g>

        <g opacity="0.1">
          <g opacity="0.87">
            <rect
              x="291.461"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="269.308"
              y="5.53741"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 5.53741)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="285.923"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="274.846"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="291.461"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="269.308"
              y="11.0764"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 11.0764)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="285.923"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="274.846"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="280.384"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.384 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="291.461"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="269.308"
              y="16.6149"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 16.6149)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="285.923"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="274.846"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="280.384"
              y="22.1532"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.384 22.1532)"
              fill="#103037"
              fillOpacity="0.5"
            />
            <rect
              x="280.384"
              y="27.6917"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.384 27.6917)"
              fill="#103037"
              fillOpacity="0.5"
            />
          </g>
        </g>
      </motion.g>

      {/* Row 2 - Second section (y ~47-69) */}
      <motion.g
        variants={arrowVariants}
        initial="hidden"
        animate="visible"
        custom={1}
      >
        <g opacity="0.1">
          <g opacity="0.94">
            <rect
              x="30.4614"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="8.30811"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="24.9229"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="13.8462"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="30.4614"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="8.30811"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="24.9229"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="13.8462"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="19.3848"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3848 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="30.4614"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="8.30811"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="24.9229"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="13.8462"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="19.3848"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3848 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="19.3848"
              y="69.3483"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3848 69.3483)"
              fill="#103037"
              fillOpacity="0.7"
            />
          </g>
        </g>

        <g opacity="0.14">
          <g opacity="0.94">
            <rect
              x="95.7114"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="73.5581"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5581 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="90.1729"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="79.0962"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="95.7114"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="73.5581"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5581 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="90.1729"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="79.0962"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="84.6348"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6348 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="95.7114"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="73.5581"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5581 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="90.1729"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="79.0962"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="84.6348"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6348 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="84.6348"
              y="69.3483"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6348 69.3483)"
              fill="#103037"
              fillOpacity="0.7"
            />
          </g>
        </g>

        <g filter="url(#filter0_d_4292_2547)">
          <g opacity="0.73">
            <rect
              x="160.961"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="138.808"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="155.423"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="144.346"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="160.961"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="138.808"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="155.423"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="144.346"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="149.884"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="160.961"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="138.808"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="155.423"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="144.346"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="149.884"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="149.884"
              y="69.3483"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 69.3483)"
              fill="#103037"
              fillOpacity="0.7"
            />
          </g>
        </g>

        <g opacity="0.14">
          <g opacity="0.94">
            <rect
              x="226.211"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="204.058"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="220.673"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="209.596"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="226.211"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="204.058"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="220.673"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="209.596"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="215.135"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.135 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="226.211"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="204.058"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="220.673"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="209.596"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="215.135"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.135 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="215.135"
              y="69.3483"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.135 69.3483)"
              fill="#103037"
              fillOpacity="0.7"
            />
          </g>
        </g>

        <g opacity="0.1">
          <g opacity="0.94">
            <rect
              x="291.461"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="269.308"
              y="47.194"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 47.194)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="285.923"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="274.846"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="291.461"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="269.308"
              y="52.733"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 52.733)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="285.923"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="274.846"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="280.385"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.385 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="291.461"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="269.308"
              y="58.2715"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 58.2715)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="285.923"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="274.846"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="280.385"
              y="63.8098"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.385 63.8098)"
              fill="#103037"
              fillOpacity="0.7"
            />
            <rect
              x="280.385"
              y="69.3483"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.385 69.3483)"
              fill="#103037"
              fillOpacity="0.7"
            />
          </g>
        </g>
      </motion.g>

      {/* Row 3 - Third section (y ~88-111) */}
      <motion.g
        variants={arrowVariants}
        initial="hidden"
        animate="visible"
        custom={2}
      >
        <g opacity="0.1">
          <g opacity="0.95">
            <rect
              x="30.4614"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 88.8508)"
              fill="#103037"
            />
            <rect
              x="8.30811"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 88.8508)"
              fill="#103037"
            />
            <rect
              x="24.9229"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 94.3896)"
              fill="#103037"
            />
            <rect
              x="13.8462"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 94.3896)"
              fill="#103037"
            />
            <rect
              x="30.4614"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 94.3896)"
              fill="#103037"
            />
            <rect
              x="8.30811"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 94.3896)"
              fill="#103037"
            />
            <rect
              x="24.9229"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 99.9282)"
              fill="#103037"
            />
            <rect
              x="13.8462"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 99.9282)"
              fill="#103037"
            />
            <rect
              x="19.3848"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3848 99.9282)"
              fill="#103037"
            />
            <rect
              x="30.4614"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 30.4614 99.9282)"
              fill="#103037"
            />
            <rect
              x="8.30811"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 8.30811 99.9282)"
              fill="#103037"
            />
            <rect
              x="24.9229"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 24.9229 105.466)"
              fill="#103037"
            />
            <rect
              x="13.8462"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 13.8462 105.466)"
              fill="#103037"
            />
            <rect
              x="19.3848"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3848 105.466)"
              fill="#103037"
            />
            <rect
              x="19.3848"
              y="111.005"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 19.3848 111.005)"
              fill="#103037"
            />
          </g>
        </g>

        <g opacity="0.14">
          <g opacity="0.95">
            <rect
              x="95.7114"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 88.8508)"
              fill="#103037"
            />
            <rect
              x="73.5581"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5581 88.8508)"
              fill="#103037"
            />
            <rect
              x="90.1729"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 94.3896)"
              fill="#103037"
            />
            <rect
              x="79.0962"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 94.3896)"
              fill="#103037"
            />
            <rect
              x="95.7114"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 94.3896)"
              fill="#103037"
            />
            <rect
              x="73.5581"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5581 94.3896)"
              fill="#103037"
            />
            <rect
              x="90.1729"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 99.9282)"
              fill="#103037"
            />
            <rect
              x="79.0962"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 99.9282)"
              fill="#103037"
            />
            <rect
              x="84.6348"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6348 99.9282)"
              fill="#103037"
            />
            <rect
              x="95.7114"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 95.7114 99.9282)"
              fill="#103037"
            />
            <rect
              x="73.5581"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 73.5581 99.9282)"
              fill="#103037"
            />
            <rect
              x="90.1729"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 90.1729 105.466)"
              fill="#103037"
            />
            <rect
              x="79.0962"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 79.0962 105.466)"
              fill="#103037"
            />
            <rect
              x="84.6348"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6348 105.466)"
              fill="#103037"
            />
            <rect
              x="84.6348"
              y="111.005"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 84.6348 111.005)"
              fill="#103037"
            />
          </g>
        </g>

        <g filter="url(#filter0_d_4292_2547)">
          <g opacity="0.74">
            <rect
              x="160.961"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 88.8508)"
              fill="#103037"
            />
            <rect
              x="138.808"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 88.8508)"
              fill="#103037"
            />
            <rect
              x="155.423"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 94.3896)"
              fill="#103037"
            />
            <rect
              x="144.346"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 94.3896)"
              fill="#103037"
            />
            <rect
              x="160.961"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 94.3896)"
              fill="#103037"
            />
            <rect
              x="138.808"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 94.3896)"
              fill="#103037"
            />
            <rect
              x="155.423"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 99.9282)"
              fill="#103037"
            />
            <rect
              x="144.346"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 99.9282)"
              fill="#103037"
            />
            <rect
              x="149.884"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 99.9282)"
              fill="#103037"
            />
            <rect
              x="160.961"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 160.961 99.9282)"
              fill="#103037"
            />
            <rect
              x="138.808"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 138.808 99.9282)"
              fill="#103037"
            />
            <rect
              x="155.423"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 155.423 105.466)"
              fill="#103037"
            />
            <rect
              x="144.346"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 144.346 105.466)"
              fill="#103037"
            />
            <rect
              x="149.884"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 105.466)"
              fill="#103037"
            />
            <rect
              x="149.884"
              y="111.005"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 149.884 111.005)"
              fill="#103037"
            />
          </g>
        </g>

        <g opacity="0.14">
          <g opacity="0.95">
            <rect
              x="226.211"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 88.8508)"
              fill="#103037"
            />
            <rect
              x="204.058"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 88.8508)"
              fill="#103037"
            />
            <rect
              x="220.673"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 94.3896)"
              fill="#103037"
            />
            <rect
              x="209.596"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 94.3896)"
              fill="#103037"
            />
            <rect
              x="226.211"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 94.3896)"
              fill="#103037"
            />
            <rect
              x="204.058"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 94.3896)"
              fill="#103037"
            />
            <rect
              x="220.673"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 99.9282)"
              fill="#103037"
            />
            <rect
              x="209.596"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 99.9282)"
              fill="#103037"
            />
            <rect
              x="215.135"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.135 99.9282)"
              fill="#103037"
            />
            <rect
              x="226.211"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 226.211 99.9282)"
              fill="#103037"
            />
            <rect
              x="204.058"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 204.058 99.9282)"
              fill="#103037"
            />
            <rect
              x="220.673"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 220.673 105.466)"
              fill="#103037"
            />
            <rect
              x="209.596"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 209.596 105.466)"
              fill="#103037"
            />
            <rect
              x="215.135"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.135 105.466)"
              fill="#103037"
            />
            <rect
              x="215.135"
              y="111.005"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 215.135 111.005)"
              fill="#103037"
            />
          </g>
        </g>

        <g opacity="0.1">
          <g opacity="0.95">
            <rect
              x="291.461"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 88.8508)"
              fill="#103037"
            />
            <rect
              x="269.308"
              y="88.8508"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 88.8508)"
              fill="#103037"
            />
            <rect
              x="285.923"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 94.3896)"
              fill="#103037"
            />
            <rect
              x="274.846"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 94.3896)"
              fill="#103037"
            />
            <rect
              x="291.461"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 94.3896)"
              fill="#103037"
            />
            <rect
              x="269.308"
              y="94.3896"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 94.3896)"
              fill="#103037"
            />
            <rect
              x="285.923"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 99.9282)"
              fill="#103037"
            />
            <rect
              x="274.846"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 99.9282)"
              fill="#103037"
            />
            <rect
              x="280.385"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.385 99.9282)"
              fill="#103037"
            />
            <rect
              x="291.461"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 291.461 99.9282)"
              fill="#103037"
            />
            <rect
              x="269.308"
              y="99.9282"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 269.308 99.9282)"
              fill="#103037"
            />
            <rect
              x="285.923"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 285.923 105.466)"
              fill="#103037"
            />
            <rect
              x="274.846"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 274.846 105.466)"
              fill="#103037"
            />
            <rect
              x="280.385"
              y="105.466"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.385 105.466)"
              fill="#103037"
            />
            <rect
              x="280.385"
              y="111.005"
              width="2.7692"
              height="2.7692"
              rx="0.553841"
              transform="rotate(90 280.385 111.005)"
              fill="#103037"
            />
          </g>
        </g>
      </motion.g>

      {/* Row 4 - Bottom section (y ~130-152) */}
      <motion.g
        variants={arrowVariants}
        initial="hidden"
        animate="visible"
        custom={3}
      >
        <g opacity="0.1">
          <rect
            x="30.4614"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 30.4614 130.508)"
            fill="#103037"
          />
          <rect
            x="8.30811"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 8.30811 130.508)"
            fill="#103037"
          />
          <rect
            x="24.9229"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 24.9229 136.046)"
            fill="#103037"
          />
          <rect
            x="13.8462"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 13.8462 136.046)"
            fill="#103037"
          />
          <rect
            x="30.4614"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 30.4614 136.046)"
            fill="#103037"
          />
          <rect
            x="8.30811"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 8.30811 136.046)"
            fill="#103037"
          />
          <rect
            x="24.9229"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 24.9229 141.585)"
            fill="#103037"
          />
          <rect
            x="13.8462"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 13.8462 141.585)"
            fill="#103037"
          />
          <rect
            x="19.3848"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 19.3848 141.585)"
            fill="#103037"
          />
          <rect
            x="30.4614"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 30.4614 141.585)"
            fill="#103037"
          />
          <rect
            x="8.30811"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 8.30811 141.585)"
            fill="#103037"
          />
          <rect
            x="24.9229"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 24.9229 147.123)"
            fill="#103037"
          />
          <rect
            x="13.8462"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 13.8462 147.123)"
            fill="#103037"
          />
          <rect
            x="19.3848"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 19.3848 147.123)"
            fill="#103037"
          />
          <rect
            x="19.3848"
            y="152.662"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 19.3848 152.662)"
            fill="#103037"
          />
        </g>

        <g opacity="0.14">
          <rect
            x="95.7114"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 95.7114 130.508)"
            fill="#103037"
          />
          <rect
            x="73.5581"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 73.5581 130.508)"
            fill="#103037"
          />
          <rect
            x="90.1729"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 90.1729 136.046)"
            fill="#103037"
          />
          <rect
            x="79.0962"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 79.0962 136.046)"
            fill="#103037"
          />
          <rect
            x="95.7114"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 95.7114 136.046)"
            fill="#103037"
          />
          <rect
            x="73.5581"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 73.5581 136.046)"
            fill="#103037"
          />
          <rect
            x="90.1729"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 90.1729 141.585)"
            fill="#103037"
          />
          <rect
            x="79.0962"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 79.0962 141.585)"
            fill="#103037"
          />
          <rect
            x="84.6348"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 84.6348 141.585)"
            fill="#103037"
          />
          <rect
            x="95.7114"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 95.7114 141.585)"
            fill="#103037"
          />
          <rect
            x="73.5581"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 73.5581 141.585)"
            fill="#103037"
          />
          <rect
            x="90.1729"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 90.1729 147.123)"
            fill="#103037"
          />
          <rect
            x="79.0962"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 79.0962 147.123)"
            fill="#103037"
          />
          <rect
            x="84.6348"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 84.6348 147.123)"
            fill="#103037"
          />
          <rect
            x="84.6348"
            y="152.662"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 84.6348 152.662)"
            fill="#103037"
          />
        </g>

        <g filter="url(#filter0_d_4292_2547)">
          <rect
            x="160.961"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 160.961 130.508)"
            fill="#103037"
          />
          <rect
            x="138.808"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 138.808 130.508)"
            fill="#103037"
          />
          <rect
            x="155.423"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 155.423 136.046)"
            fill="#103037"
          />
          <rect
            x="144.346"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 144.346 136.046)"
            fill="#103037"
          />
          <rect
            x="160.961"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 160.961 136.046)"
            fill="#103037"
          />
          <rect
            x="138.808"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 138.808 136.046)"
            fill="#103037"
          />
          <rect
            x="155.423"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 155.423 141.585)"
            fill="#103037"
          />
          <rect
            x="144.346"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 144.346 141.585)"
            fill="#103037"
          />
          <rect
            x="149.884"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 149.884 141.585)"
            fill="#103037"
          />
          <rect
            x="160.961"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 160.961 141.585)"
            fill="#103037"
          />
          <rect
            x="138.808"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 138.808 141.585)"
            fill="#103037"
          />
          <rect
            x="155.423"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 155.423 147.123)"
            fill="#103037"
          />
          <rect
            x="144.346"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 144.346 147.123)"
            fill="#103037"
          />
          <rect
            x="149.884"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 149.884 147.123)"
            fill="#103037"
          />
          <rect
            x="149.884"
            y="152.662"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 149.884 152.662)"
            fill="#103037"
          />
        </g>

        <g opacity="0.14">
          <rect
            x="226.211"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 226.211 130.508)"
            fill="#103037"
          />
          <rect
            x="204.058"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 204.058 130.508)"
            fill="#103037"
          />
          <rect
            x="220.673"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 220.673 136.046)"
            fill="#103037"
          />
          <rect
            x="209.596"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 209.596 136.046)"
            fill="#103037"
          />
          <rect
            x="226.211"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 226.211 136.046)"
            fill="#103037"
          />
          <rect
            x="204.058"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 204.058 136.046)"
            fill="#103037"
          />
          <rect
            x="220.673"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 220.673 141.585)"
            fill="#103037"
          />
          <rect
            x="209.596"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 209.596 141.585)"
            fill="#103037"
          />
          <rect
            x="215.135"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 215.135 141.585)"
            fill="#103037"
          />
          <rect
            x="226.211"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 226.211 141.585)"
            fill="#103037"
          />
          <rect
            x="204.058"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 204.058 141.585)"
            fill="#103037"
          />
          <rect
            x="220.673"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 220.673 147.123)"
            fill="#103037"
          />
          <rect
            x="209.596"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 209.596 147.123)"
            fill="#103037"
          />
          <rect
            x="215.135"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 215.135 147.123)"
            fill="#103037"
          />
          <rect
            x="215.135"
            y="152.662"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 215.135 152.662)"
            fill="#103037"
          />
        </g>

        <g opacity="0.1">
          <rect
            x="291.461"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 291.461 130.508)"
            fill="#103037"
          />
          <rect
            x="269.308"
            y="130.508"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 269.308 130.508)"
            fill="#103037"
          />
          <rect
            x="285.923"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 285.923 136.046)"
            fill="#103037"
          />
          <rect
            x="274.846"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 274.846 136.046)"
            fill="#103037"
          />
          <rect
            x="291.461"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 291.461 136.046)"
            fill="#103037"
          />
          <rect
            x="269.308"
            y="136.046"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 269.308 136.046)"
            fill="#103037"
          />
          <rect
            x="285.923"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 285.923 141.585)"
            fill="#103037"
          />
          <rect
            x="274.846"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 274.846 141.585)"
            fill="#103037"
          />
          <rect
            x="280.385"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 280.385 141.585)"
            fill="#103037"
          />
          <rect
            x="291.461"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 291.461 141.585)"
            fill="#103037"
          />
          <rect
            x="269.308"
            y="141.585"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 269.308 141.585)"
            fill="#103037"
          />
          <rect
            x="285.923"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 285.923 147.123)"
            fill="#103037"
          />
          <rect
            x="274.846"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 274.846 147.123)"
            fill="#103037"
          />
          <rect
            x="280.385"
            y="147.123"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 280.385 147.123)"
            fill="#103037"
          />
          <rect
            x="280.385"
            y="152.662"
            width="2.7692"
            height="2.7692"
            rx="0.553841"
            transform="rotate(90 280.385 152.662)"
            fill="#103037"
          />
        </g>
      </motion.g>

      <defs>
        <filter
          id="filter0_d_4292_2547"
          x="121.05"
          y="-4.95"
          width="54.9"
          height="179.87"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.5" />
          <feGaussianBlur stdDeviation="4.725" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0634477 0 0 0 0 0.188315 0 0 0 0 0.216346 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4292_2547"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4292_2547"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
